import React, { useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import '../css/LandDetails.css';
import NavbarComponent from './Navbar';
import FooterComponent from './Footer';
import Seo from '../components/Seo';
import 'font-awesome/css/font-awesome.min.css'
import { COMMON_CONSTANTS } from '../constants/Common'

const { config: { default_map_location } } = COMMON_CONSTANTS


const LandDetails = () => {
    const location = useLocation();
    // console.log('location========', location.state)
    const [land] = useState(location.state?.landDetails || null);
    const [getSellerInfo, setgetSellerInfo] = useState(false)
    const navigate = useNavigate()

    if (!land) {
        return <p className="not-found">Land not found.</p>;
    }

    const MapIcon = () => (
        <i className="fa fa-map-marker" style={{ fontSize: '40px', color: 'red' }}></i>
    );
    const handleUserInfo = (e) => {
        e.preventDefault()
            const isLoggedIn = localStorage.getItem('isLoggedIn')
    // console.log('is logged in', isLoggedIn)
    if (!isLoggedIn) {
      navigate('/login')
    }
        setgetSellerInfo(true)
    }

    const handlePopupClose = () => {
        setgetSellerInfo(false)
    }



    return (
        <>
            <Seo
                title="Land Details - KhetBazaar"
                description="View detailed information about selected land listings."
                canonical={`https://khetbazaar.in/land-details/${land?.landId}`}
            />

            <NavbarComponent />
            <div className="land-details-page">
                <h1 className="land-header">{`${land.landType}`} Land For Sale/Lease</h1>
                <div className="land-details-wrapper">
                    {/* Left Section: Image or Map */}
                    <div className="land-image-slider">
                        <img
                            src={land.imageUrl}
                            alt={`${land.category} in ${land.location}`}
                            className="land-main-image"
                        />
                        <div className="land-location">
                            <a href={land.mapUrl || default_map_location} target="_blank" rel="noopener noreferrer">
                                <span>{MapIcon()}</span> View on Map
                            </a>
                        </div>
                        {/* <div className="slider-controls">
                            <button className="slider-prev">PREV</button>
                            <button className="slider-next">NEXT</button>
                        </div> */}
                    </div>

                    {/* Right Section: Details */}
                    <div className="land-info">
                        <h2> Land Owner:   {land.landOwnerName}</h2>
                        <p>
                            <strong>Land Type:</strong> {land.landType}
                        </p>
                        <p>
                            <strong>Description:</strong> {land.landDescription}
                        </p>
                        <p>
                            <strong>Address:</strong>{land.address}
                            {/* <button className="view-address-btn" onClick={handleAddress}>View Address</button> */}
                        </p>
                        <p>
                            <strong>Listed On:</strong> {new Date(land.createdAt).toLocaleString()}
                        </p>
                        <p>
                            <strong>ID:</strong> {land.landId}
                        </p>
                        <p>
                            <strong>Total Area:</strong> {land.area} Acre
                        </p>
                        <p>
                            <strong>Price:</strong> {land.pricePerAcer} lakh / Acre
                        </p>
                        {/* <p>
            <strong>Property Type:</strong> {land.propertyType}
          </p> */}
                        <p>
                            <strong>Posted By:</strong> {land.postedBy}
                        </p>
                        <p>
                            <strong>Is Irrigated:</strong> {land.isIrrigated ? land.isIrrigated : 'Yes'}
                        </p>
                        <div className="action-buttons">
                            {
                                getSellerInfo && (
                                    <div className="popup">
                                        <div className="popup-content">
                                            <p> Owner Name: {land.landOwnerName}</p>
                                            <p> Owner Phone: {land.landOwnerPhone}</p>
                                            <p> Email: {land.email}</p>
                                            <button onClick={handlePopupClose}>OK</button>
                                        </div>
                                    </div>
                                )
                            }
                            <button className="make-offer-btn" onClick={handleUserInfo}>Contact Seller</button>
                        </div>
                    </div>
                </div>
            </div>
            <FooterComponent />
        </>

    );
};



export default LandDetails;
